/*!
 * Caron dimonio, con occhi di bragia
 * loro accennando, tutte le raccoglie;
 * batte col remo qualunque s’adagia 
 *
 * Charon the demon, with the eyes of glede,
 * Beckoning to them, collects them all together,
 * Beats with his oar whoever lags behind
 *          
 *          Dante - The Divine Comedy (Canto III)
 */

module.exports = require('./lib/http-proxy');


//////////////////
// WEBPACK FOOTER
// ./~/http-proxy/index.js
// module id = 3041
// module chunks = 0